const isObject = (value: unknown): value is Record<string, unknown> => {
  return value !== null && !Array.isArray(value) && typeof value === 'object'
}

// プリミティブ / 配列 / オブジェクトを再帰的に渡り歩き、オブジェクトの key だけ
// convertFunction で変換する。consumer (custom-fetch.ts の onRequest / onResponse) は
// $fetch の body / query / params / response._data を渡してくるため広く unknown で受ける。
export const convertKeyRecursively = (
  data: unknown,
  convertFunction: (key: string) => string
): unknown => {
  if (Array.isArray(data)) {
    return data.map((element) => convertKeyRecursively(element, convertFunction))
  }
  if (!isObject(data)) {
    return data
  }
  const result: Record<string, unknown> = {}
  Object.keys(data).forEach((key) => {
    result[convertFunction(key)] = convertKeyRecursively(data[key], convertFunction)
  })
  return result
}
